import authCheckApp from './authCheckApp'

/**
 * 关闭当前页面（webview）
 * @since 1.0.0
 * @example
 * 
 * closeWebView()
 */
function closeWebView() {
    authCheckApp()
        .then(() => {
        // 发起请求
            window.WebViewJavascriptBridge.callHandler('closeWebView', {}, (response) => {
                return response
            })
        }).catch(err => {
            Promise.reject(err)
        })
}

export default closeWebView